import { default as Mutual } from "./Mutual";
import { default as CoInvitations } from "./CoInvitations";
import { default as RentPayments } from "./RentPayments";
import { default as UtilityBills } from "./UtilityBills";
import { default as Files } from "./Files";
import { default as Services } from "./Services";
import { default as CalendarEventsProperties } from "./CalendarEventsProperties";
import { default as Cases } from "./Cases";
import { default as Wallets } from "./Wallets";
import { default as Transactions } from "./Transactions";
import { default as SharedWallets } from "./SharedWallets";
import { default as BankIntegrations } from "./BankIntegrations";
import { default as ChatTodos } from "./ChatTodos";
import { default as Folders } from "./Folders";
import { default as AssistantProperties } from "./AssistantProperties";
import { default as LandlordTenantInvitations } from "./LandlordTenantInvitations";
import { default as SharedManagementInvitations } from "./SharedManagementInvitations";

// ✅ Community Components (from Neighbors folder but renamed for Communities)
import { default as Notices } from "./Neighbors/Notices";
import { default as CalendarCommunities } from "./Neighbors/CalendarCommunities";
import { default as FilesCommunities } from "./Neighbors/FilesCommunities";
import { default as AssistantCommunities } from "./Neighbors/AssistantCommunities";
import { default as MeetingsCommunities } from "./Neighbors/MeetingsCommunities";
import { default as WalletsCommunities } from "./Neighbors/WalletsCommunities";
import { default as Polls } from "./Neighbors/Polls";
import { default as Payments } from "./Neighbors/Payments";

// ✅ NEW: Additional Community Components
import { default as ChatsCommunities } from "./Neighbors/ChatsCommunities";
import { default as TransactionsCommunities } from "./Neighbors/TransactionsCommunities";
import { default as FoldersCommunities } from "./Neighbors/FoldersCommunities";
import { default as AdministratorsCommunities } from "./Neighbors/AdministratorsCommunities";
import { default as ParticipantsCommunities } from "./Neighbors/ParticipantsCommunities";
import { default as PrintMaterialsCommunities } from "./Neighbors/PrintMaterialsCommunities";
import { default as CommunityUtilityBills } from "./CommunityUtilityBills/CommunityUtilityBills";
import { default as FreeUsers } from "./FreeUsers";
import { default as SubscribedUsers } from "./SubscribedUsers";
import { default as FreeCommunities } from "./FreeCommunities";
import { default as SubscribedCommunities } from "./SubscribedCommunities";
import { default as CommunitiesList } from "./CommunitiesList/CommunitiesList";
import { default as UsersList } from "./UsersList/UsersList";
import { default as PropertiesList } from "./PropertiesList/PropertiesList";
import { default as UserSearch } from "./UserSearch/UserSearch";

// ✅ Create placeholder components for missing ones
const CommunityFunds = () => (
  <div className="placeholder-tab">
    <h3>COMMUNITY FUNDS</h3>
    <p>Component under development...</p>
  </div>
);

const AppGrids = {
  // Existing Property & Finance Components
  Mutual,
  CoInvitations,
  RentPayments,
  UtilityBills,
  Files,
  CalendarEventsProperties,
  Cases,
  Services,
  Wallets,
  Transactions,
  SharedWallets,
  BankIntegrations,
  ChatTodos,
  Folders,
  AssistantProperties,
  LandlordTenantInvitations,
  SharedManagementInvitations,

  // ✅ Community Components (matching AppCommunities.js expectations)
  CommunityNotices: Notices,
  CommunityCalendar: CalendarCommunities,
  CommunityMeetings: MeetingsCommunities,
  CommunityFiles: FilesCommunities,
  CommunityFolders: FoldersCommunities,
  CommunityWallets: WalletsCommunities,
  CommunityUtilityBills,
  CommunityFunds,
  CommunityServices: AssistantCommunities,
  CommunityMembers: ParticipantsCommunities, // ✅ Now real component
  CommunityPrintOrders: PrintMaterialsCommunities, // ✅ Now real component
  CommunityUtilityBills, // ✅ NEW: Utility Bills component
  FreeUsers, // ✅ NEW: Free Users table component
  SubscribedUsers, // ✅ NEW: Subscribed Users table component
  FreeCommunities, // ✅ NEW: Free Communities table component
  SubscribedCommunities, // ✅ NEW: Subscribed Communities table component
  CommunitiesList, // ✅ NEW: Communities List table component
  UsersList, // ✅ NEW: Users List table component
  PropertiesList, // ✅ NEW: Properties List table component
  UserSearch, // ✅ NEW: User Search component

  // ✅ NEW: Additional community mappings for your 13-card structure
  CommunityChats: ChatsCommunities,
  CommunityTransactions: TransactionsCommunities,
  CommunityAdministrators: AdministratorsCommunities,
  CommunityParticipants: ParticipantsCommunities,
  CommunityPrintMaterials: PrintMaterialsCommunities, // ✅ NEW: Real component

  // ✅ Keep old names for backward compatibility
  Notices,
  CalendarCommunities,
  FilesCommunities,
  AssistantCommunities,
  MeetingsCommunities,
  WalletsCommunities,
  Polls,
  Payments,
  ChatsCommunities,
  TransactionsCommunities,
  FoldersCommunities,
  AdministratorsCommunities,
  ParticipantsCommunities,
  PrintMaterialsCommunities,
};

export default AppGrids;